import React, { useState } from "react";
import "../ui/table/table.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faTrashCan, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./salesTable.css";

const PAGE_SIZE = 10;

const SalesTable = ({
  data = [],
  loading = false,
  editable = false,
  onView,
  onEdit,
  onDelete,
  showViewAll = false,
}) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / PAGE_SIZE));
  const paginated = data.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // Reset to page 1 when data changes
  React.useEffect(() => { setPage(1); }, [data.length]);

  if (loading) return <p>Loading sales...</p>;

  return (
    <div className="card">
      <div className="card-header">
        <h3>Recent Sales</h3>
        <span className="table-count">{data.length} record{data.length !== 1 ? "s" : ""}</span>
        {showViewAll && <Link to="/sales" className="viewbtn">View All</Link>}
      </div>

      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Date</th>
              <th>Items</th>
              <th>Amount</th>
              <th>Payment</th>
              {editable && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 ? (
              <tr>
                <td colSpan={editable ? 7 : 6} style={{ textAlign: "center", padding: "2rem", color: "#888" }}>
                  No sales found.
                </td>
              </tr>
            ) : (
              paginated.map((sale, idx) => (
                <tr key={sale._id}>
                  <td className="sale-id">#{sale._id.slice(-6).toUpperCase()}</td>
                  <td>{sale.walkInCustomer || "Walk-in"}</td>
                  <td>{new Date(sale.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</td>
                  <td>{sale.items.length} item{sale.items.length !== 1 ? "s" : ""}</td>
                  <td>₹{sale.total?.toLocaleString("en-IN")}</td>
                  <td>
                    <span className={`payment-badge ${sale.paymentType}`}>
                      {sale.paymentType
                        ? sale.paymentType.charAt(0).toUpperCase() + sale.paymentType.slice(1)
                        : "—"}
                    </span>
                  </td>
                  {editable && (
                    <td>
                      <div className="action-btns">
                        {onView && (
                          <button className="action-btn view" onClick={() => onView(sale)} title="View">
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                        )}
                        {onEdit && (
                          <button className="action-btn edit" onClick={() => onEdit(sale)} title="Edit">
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </button>
                        )}
                        {onDelete && (
                          <button className="action-btn delete" onClick={() => onDelete(sale)} title="Delete">
                            <FontAwesomeIcon icon={faTrashCan} />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {data.length > PAGE_SIZE && (
        <div className="pagination-bar">
          <button
            className="page-btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <span className="page-info">Page {page} of {totalPages}</span>
          <button
            className="page-btn"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default SalesTable;
